import React, { FC } from 'react'
import { FormikProps } from 'formik'
import Radio, { IRadio } from '../Radio'

interface IRadioForm extends Omit<IRadio, 'checked'> {
  formik: FormikProps<any>
  children?: React.ReactNode
}

const RadioForm: FC<IRadioForm> = ({
  name,
  value,
  formik,
  children,
  ...props
}) => {
  const { setFieldValue, getFieldMeta } = formik;

  const {value: valueField} = getFieldMeta(name);

  const changeField = (e: React.MouseEvent<HTMLGxRadioElement, MouseEvent>) => {
    setFieldValue(name, (e.target as HTMLGxRadioElement).value);
  };

  return (
    <Radio
      checked={String(valueField) === String(value)}
      value={value}
      name={name}
      onClick={changeField}
      {...props}
    >
      {children}
    </Radio>
  );
};

export default RadioForm;
